import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { BansStorageService } from '../../services/bans-storage.service';
import { BillingPortalProps } from '../../models/BillingPortalProps';
import { InvoicesService } from '../../services/invoices.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-paperless-billing',
  templateUrl: './paperless-billing.component.html',
  styleUrls: ['./paperless-billing.component.css']
})
export class PaperlessBillingComponent implements OnInit {
  @Input() banCAs: Map<string, string[]> = new Map();

  @Output() selectedBAN = new EventEmitter<any>();

  url: any;
  data: any;
  ban: string = "";
  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  customerIDs: Array<string> = [];
  banflag: boolean = false;
  apigeeToken: any;
  isBansPresent: Boolean = true;

  
  PaperlessStatus: any; 
  paperlessStatusMap: { [key: string]: any } = {};
  banKeys: string = '';
  isLoadMore: boolean = false;
  isPaperlessStatus: boolean = false;
  showLoader: boolean = true;

  bansPerPage: number = 10;
  currentPage: number = 1;
  displayedBans: Map<string, string[]> = new Map();
  allBans: Map<string, string[]> = new Map();

  selectedRows: Set<string> = new Set();
  BanSearch: any = '';

  menuBtnClick: boolean = false;
  searchInput: string = '';
  errorMessage: string = "";
  showErrPopup: boolean = false;
  @ViewChild('searchInputRef') searchInputElement!: ElementRef;

  constructor(private sanitizer: DomSanitizer, private bansService: BansStorageService, private invoicesService: InvoicesService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void{
    this.getBans();
  }

    isRowSelected(banKey: string): boolean {
      return this.selectedRows.has(banKey);
    }
  
    isAllSelected(): boolean {
      return this.selectedRows.size === this.getBANs.size;
    }
  
    toggleRowSelection(banKey: string): void {
      if (this.selectedRows.has(banKey)) {
        this.selectedRows.delete(banKey);
        console.log(`Row with BAN ${banKey} deselected`);
      } else {
        this.selectedRows.add(banKey);
        console.log(`Row with BAN ${banKey} selected`);
      }
      if (this.selectedRows.size > 0) {
        console.log(`There are ${this.selectedRows.size} rows selected`);
      } else {
        console.log('No rows are selected');
      }
    }
  
    toggleSelectAll(event: any): void {
      if (event.target.checked) {
        this.selectedRows.clear();
        this.getBANs.forEach((value, key) => this.selectedRows.add(key));
        console.log('All rows selected');
      } else {
        this.selectedRows.clear();
        console.log('All rows deselected');
      }
  
      if (this.isAllSelected()) {
        console.log('All rows are selected');
      } else if (this.selectedRows.size > 0) {
        console.log(`There are ${this.selectedRows.size} rows selected`);
      } else {
        console.log('No rows are selected');
      }
    }

    onSearchChange(): void {
      this.loadMoreBans();
      console.log("Search term:", this.searchInput);
      if (this.searchInput) {
        const filteredEntries = Array.from(this.allBans.entries())
        .filter(([key, _]) => key.includes(this.searchInput));
        this.displayedBans = new Map(filteredEntries);
        console.log(this.getBANs);
      } else {
        this.displayedBans = this.allBans;
        console.log("backspace")
      }
    }

    getPaperlessIndicator(bans: string): void {
      console.log("Calling API with bans:", bans);
      this.invoicesService.getPaperlessBilling(bans).subscribe(
        (data) => {
          console.log("Received paperless billing data for bans:",data); 
          this.PaperlessStatus = data;
          this.isPaperlessStatus = true;
          this.showLoader = false;
          return data;
        }
      )
  }

  getDataByBan(ban: string) {
    return this.PaperlessStatus.filter((item: any) => item.ban === ban);
  }

  updateStatus(ban: string, currentPaperlessIndicator: string) {
    const newPaperlessIndicator = currentPaperlessIndicator === 'ZY' ? 'ZN' : 'ZY';
    console.log('Current Paperless Indicator:', currentPaperlessIndicator);
    console.log('New Paperless Indicator:', newPaperlessIndicator);
    this.invoicesService.UpdatePaperlessIndicator(ban, newPaperlessIndicator).subscribe(
      (data) => {
        console.log('API Response:', data);
        this.cdr.markForCheck();
        this.getPaperlessIndicator(this.banKeys);
      },
      (error) => {
        console.error('Error updating paperless indicator:', error);
        this.errorMessage = error
        this.showErrPopup = true
        this.getPaperlessIndicator(this.banKeys);
      }
    );
  }

  getBans() {
    this.bansService.bans.subscribe((bans: Map<string, string[]>) => {
      console.log("Received bans from service:", bans);
      if (bans) {
        this.banCAs = bans;
        this.banKeys = Array.from(this.banCAs.keys()).join(', '); 
        console.log("Comma-separated keys:", this.banKeys);
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];

        this.loadBansForPage();

        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.serverFURL + "invoices/speedframe?original=" + window.origin + "&ban=" + this.ban + "&callbackurl=/invoices");
        this.getPaperlessIndicator(this.banKeys);
      }
    });
  }

  loadBansForPage(): void {
    if (this.currentPage === 1) {
    const startIndex = (this.currentPage - 1) * this.bansPerPage;
    const endIndex = startIndex + this.bansPerPage;

    const pageBans: [string, string[]][] = Array.from(this.banCAs.entries()).slice(startIndex, endIndex);

    pageBans.forEach(([key, value]) => {
      this.displayedBans.set(key, value);
      this.allBans.set(key, value);
    });
  } else{
    const allBans: [string, string[]][] = Array.from(this.banCAs.entries()).slice(this.bansPerPage);

    allBans.forEach(([key, value]) => {
      this.displayedBans.set(key, value);
      this.allBans.set(key, value);
    });
  }
  }

  loadMoreBans(): void {
    this.currentPage += 1;
    this.loadBansForPage(); 
    this.isLoadMore=true ;
  }

  get getBANs() {
    // console.log(this.displayedBans);
    return this.displayedBans; 
  }

  selectBan(selectedBan: any): void {
    this.BanSearch = '';
    localStorage.setItem("Selected_BAN_Dropdown_Value", selectedBan);
    let banCAs = this.banCAs.get(selectedBan);
    localStorage.setItem("Selected_BAN_CAs_Dropdown", JSON.stringify(banCAs)); 
    this.selectedBAN.emit(selectedBan);
  }
  clearSearchInput(): void {
    this.menuBtnClick = true;
    this.searchInput = '';
    this.searchInputElement.nativeElement.focus();
  }
  
  get getBANSearch() {
    let searchArray = new Map<string, Array<string>>();
    this.bansService.banFlag.subscribe(
      (isPresent: boolean) => {
        if (!isPresent) {
          this.isBansPresent = false;
        }
      }
    );
    if (this.searchInput) {
      for (const ban of this.banCAs.entries()) {
        if (ban[0].toLowerCase().includes(this.searchInput.toLowerCase())) {
          searchArray.set(ban[0], ban[1])
        }
      }
      return searchArray;
    }
    else {
      return this.banCAs;
    }
  }

  closePopup() {
    this.errorMessage = "";
    this.showErrPopup = false;
    return
  }
  
}
